import { LoadingService } from './../../_services/loading.service';
import { ActivatedRoute } from '@angular/router';
import { EmailIntegrationService } from './../../_services/email-integration.service';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
declare const clevertap;
const frontendurl = environment.frontendurl
@Component({
  selector: 'app-email-integration',
  templateUrl: './email-integration.component.html',
  styleUrls: ['./email-integration.component.scss']
})
export class EmailIntegrationComponent implements OnInit {
  authurl: any;
  gmailAccountDetails: any;
  outlookAccountDetails: any;
  errorMessage: any;

  constructor(private emailintegrationservice: EmailIntegrationService,private route : ActivatedRoute , private loader : LoadingService) { }

  ngOnInit() {
    this.fetchIntegration()
    window.addEventListener('storage', (event)=> {
      if(event.key == 'gmail_integration' || event.key == 'outlook_integration'){
        if (event.newValue == 'success') {
          this.fetchIntegration()
        } else {
          this.errorMessage = event.newValue;
          setTimeout(() => this.errorMessage = '', 5000);
        }
      }
      setTimeout(()=>{
        localStorage.removeItem("gmail_integration");
        localStorage.removeItem("outlook_integration");
      },2000)
    }, false);    
  }

  fetchIntegration(){
    this.emailintegrationservice.fetchintegratedemails().subscribe((res:any)=>{
     if(res.status == 'success'){
       if(res.integratedemailsarray && res.integratedemailsarray.length){
        this.gmailAccountDetails = res.integratedemailsarray.filter(x => x.integrationplatform == 'gmail')[0]
        this.outlookAccountDetails = res.integratedemailsarray.filter(x => x.integrationplatform == 'outlook')[0]
       }else{
        this.gmailAccountDetails = null
        this.outlookAccountDetails = null
       }
        this.loader.stopLoading()
     }
    })
  }

  connectoGmail(){
    let data ={
      "redirectionurl": `${frontendurl}/email_redirection?integrate=gmail`
    }
    this.emailintegrationservice.gmailintegrationurl(data).subscribe((res:any)=>{
      if(res.status == 'success'){
        this.authurl = res.url
        var winObj = window.open(this.authurl, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
        var loop = setInterval(function() {   
          if(winObj.closed) {  
            if(!localStorage.getItem('gmail_integration_completed')){
              clevertap.event.push('IntegrationAttempt_Gmail');  
            }
              clearInterval(loop);  
          }  
      }, 1000); 
      }else{
       
        this.errorMessage = res.message;
        setTimeout(() => this.errorMessage = '', 5000);
      }
    })
  }

  connectoOutlook(){
    let data ={
      "redirectionurl": `${frontendurl}/email_redirection`
    }
    this.emailintegrationservice.outlookintegrationurl(data).subscribe((res:any)=>{
      if(res.status == 'success'){
        this.authurl = res.url
        var winObj = window.open(this.authurl, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
        var loop = setInterval(function() {   
          if(winObj.closed) {  
            if(!localStorage.getItem('outlook_integration_completed')){
              clevertap.event.push('IntegrationAttempt_Outlook');
            }
              clearInterval(loop);  
          }  
      }, 1000); 
      }else{
        
        this.errorMessage = res.message;
        setTimeout(() => this.errorMessage = '', 5000);
      }
    })
  }

  disconnectEmailIntegration(type){
    let data ={
      emailid : type? this.outlookAccountDetails.emailid : this.gmailAccountDetails.emailid,
      integrationplatform : type ? 'outlook' : 'gmail'
    }

    this.emailintegrationservice.disconnectemail(data).subscribe((res:any)=>{
      data.integrationplatform == 'outlook' ? localStorage.removeItem('outlook_integration_completed') : localStorage.removeItem('gmail_integration_completed')  
      this.fetchIntegration()
    })
  }



}
